/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Checkbox, LinkHighlight, Text, TextSize } from '@sonarsource/echoes-react';
import { FormattedMessage } from 'react-intl';
import { Switch } from '~adapters/components/common/Switch';
import DocumentationLink from '~sq-server-commons/components/common/DocumentationLink';
import { DocLink } from '~sq-server-commons/helpers/doc-links';

interface SandboxSettingToggleSectionProps {
  isEnabled: boolean;
  isSwitchView?: boolean;
  onChange: (v: boolean) => void;
}

export default function SandboxSettingToggleSection({
  isEnabled,
  onChange,
  isSwitchView = false,
}: Readonly<SandboxSettingToggleSectionProps>) {
  return (
    <div className="sw-flex sw-mt-6">
      {!isSwitchView && (
        <Checkbox
          ariaLabelledBy="sandbox-setting-toggle-label"
          checked={isEnabled}
          onCheck={onChange}
        />
      )}

      {isSwitchView && (
        <Switch
          ariaLabelledBy="sandbox-setting-toggle-label"
          onChange={onChange}
          value={isEnabled}
        />
      )}

      <div className="sw-ml-3">
        <Text id="sandbox-setting-toggle-label" isHighlighted>
          <FormattedMessage id="settings.sandbox_issues.toggle.label" />
        </Text>
        <Text as="p" className="sw-mt-1" size={TextSize.Small}>
          <FormattedMessage
            id="settings.sandbox_issues.toggle.description"
            values={{
              doc: (text) => (
                <DocumentationLink
                  enableOpenInNewTab
                  highlight={LinkHighlight.CurrentColor}
                  to={DocLink.IssuesFromSonarQubeUpdate}
                >
                  {text}
                </DocumentationLink>
              ),
            }}
          />
        </Text>
      </div>
    </div>
  );
}
